/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreatePinMutationVariables = {|
  mobileNumber: string,
  pin: string,
  username: string,
  referralCode?: ?string,
|};
export type CreatePinMutationResponse = {|
  +createPin: ?{|
    +message: ?string,
    +token: ?string,
    +refreshToken: ?string,
    +error: ?boolean,
    +user: ?{|
      +id: any,
      +username: string,
      +mobileNumber: string,
      +email: ?string,
      +shortUsername: ?string,
    |},
    +wallet: ?{|
      +availableGrantMoney: ?number
    |},
  |}
|};
export type CreatePinMutation = {|
  variables: CreatePinMutationVariables,
  response: CreatePinMutationResponse,
|};
*/


/*
mutation CreatePinMutation(
  $mobileNumber: String!
  $pin: String!
  $username: String!
  $referralCode: String
) {
  createPin(mobileNumber: $mobileNumber, pin: $pin, username: $username, referralCode: $referralCode) {
    message
    token
    refreshToken
    error
    user {
      id
      username
      mobileNumber
      email
      shortUsername
    }
    wallet {
      availableGrantMoney
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mobileNumber"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pin"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "referralCode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v4 = [
  {
    "kind": "Variable",
    "name": "mobileNumber",
    "variableName": "mobileNumber"
  },
  {
    "kind": "Variable",
    "name": "pin",
    "variableName": "pin"
  },
  {
    "kind": "Variable",
    "name": "referralCode",
    "variableName": "referralCode"
  },
  {
    "kind": "Variable",
    "name": "username",
    "variableName": "username"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refreshToken",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "UserType",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortUsername",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availableGrantMoney",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePinMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CreatePin",
        "kind": "LinkedField",
        "name": "createPin",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletNode",
            "kind": "LinkedField",
            "name": "wallet",
            "plural": false,
            "selections": [
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreatePinMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CreatePin",
        "kind": "LinkedField",
        "name": "createPin",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletNode",
            "kind": "LinkedField",
            "name": "wallet",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7e4d6e1e51cadb2bd7a02fc874bd569e",
    "id": null,
    "metadata": {},
    "name": "CreatePinMutation",
    "operationKind": "mutation",
    "text": "mutation CreatePinMutation(\n  $mobileNumber: String!\n  $pin: String!\n  $username: String!\n  $referralCode: String\n) {\n  createPin(mobileNumber: $mobileNumber, pin: $pin, username: $username, referralCode: $referralCode) {\n    message\n    token\n    refreshToken\n    error\n    user {\n      id\n      username\n      mobileNumber\n      email\n      shortUsername\n    }\n    wallet {\n      availableGrantMoney\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '26046c7990b94f88167a9348b8b58c5d';

module.exports = node;
